import getTaxonPermalink from "../../utils/get-taxon-permalink";
export default function getAllTaxonPermalinksOperation({ commerce  }) {
    async function getAllTaxonPermalinks({ query , variables: getAllTaxonPathsVariables = {} , config: userConfig  } = {}) {
        //Uncomment the following line to debug
        /*     console.info(
      'getAllTaxonPermalinks called. Configuration: ',
      'query: ',
      query,
      'getAllTaxonPathsVariables: ',
      getAllTaxonPathsVariables,
      'config: ',
      userConfig
    ) */ const page = getAllTaxonPathsVariables.page;
        const variables = {
            methodPath: "taxons.list",
            arguments: [
                {
                    page
                }
            ]
        };
        const config = commerce.getConfig(userConfig);
        const { fetch: apiFetch  } = config;
        const { data: spreeSuccessResponse  } = await apiFetch("__UNUSED__", {
            variables
        });
        const normalizedTaxonsPermalinks = spreeSuccessResponse.data.map((spreeTaxon)=>({
                permalink: getTaxonPermalink(spreeTaxon)
            }));
        return {
            taxons: normalizedTaxonsPermalinks
        };
    }
    return getAllTaxonPermalinks;
};
